import React from "react";

const Toggle = ({ value, onToggle }) => (
  <div
    onClick={onToggle}
    style={{
      width: "48px",
      height: "26px",
      borderRadius: "13px",
      background: value ? "#ffca27" : "rgba(255,255,255,0.2)",
      position: "relative",
      cursor: "pointer",
      transition: "background 0.2s",
      flexShrink: 0,
    }}
  >
    <div
      style={{
        position: "absolute",
        top: "3px",
        left: value ? "25px" : "3px",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        background: "white",
        transition: "left 0.2s",
        boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
      }}
    />
  </div>
);

const SettingRow = ({ label, sublabel, value, onToggle }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1.1rem 0",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
    }}
  >
    <div style={{ flex: 1, paddingRight: "1rem" }}>
      <div style={{ color: "white", fontWeight: "600", fontSize: "14px" }}>
        {label}
      </div>
      {sublabel && (
        <div
          style={{
            color: "rgba(255,255,255,0.45)",
            fontSize: "11px",
            marginTop: "3px",
          }}
        >
          {sublabel}
        </div>
      )}
    </div>
    <Toggle value={value} onToggle={onToggle} />
  </div>
);

const GameSettingsPanel = ({ showReveal, autoPlay, onToggle, onClose }) => (
  <>
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 1099,
      }}
    />
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        height: "100%",
        width: "270px",
        background: "#1e1640",
        boxShadow: "-6px 0 32px rgba(0,0,0,0.7)",
        zIndex: 1100,
        padding: "1.5rem 1.25rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1.5rem",
          paddingBottom: "1rem",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
        }}
      >
        <span
          style={{
            color: "white",
            fontWeight: "700",
            fontSize: "16px",
            letterSpacing: "0.5px",
          }}
        >
          Game Settings
        </span>
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "rgba(255,255,255,0.6)",
            fontSize: "24px",
            cursor: "pointer",
            lineHeight: 1,
            padding: "0 4px",
          }}
        >
          ×
        </button>
      </div>
      <SettingRow
        label="Show Song Reveals"
        sublabel="Display tile reveals as they appear"
        value={showReveal}
        onToggle={() => onToggle("showReveal")}
      />
      <SettingRow
        label="Auto-play Audio"
        sublabel="Play audio automatically when song loads"
        value={autoPlay}
        onToggle={() => onToggle("autoPlay")}
      />
    </div>
  </>
);

export default GameSettingsPanel;
